module.exports = __webpack_public_path__ + "frontend/static/media/abyalatest.ddaf9349.png";